var React = require('react');

function Exclamation (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96 512a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M49.22 0h93.56a24 24 0 0 1 24 25.2l-13.63 272a24 24 0 0 1-24 22.8H62.84a24 24 0 0 1-24-22.8l-13.59-272A24 24 0 0 1 49.22 0z","className":"fa-primary","key":2})]);
}

Exclamation.defaultProps = {"viewBox":"0 0 192 512","className":"icon"};

module.exports = Exclamation;

Exclamation.default = Exclamation;
